import { useAuth } from "@/auth/AuthContext";

const Admin = () => {
  const { logout } = useAuth();

  return (
    <div style={{ padding: 40 }}>
      <h2>Admin Dashboard (Skeleton)</h2>

      <button onClick={logout}>
        Logout
      </button>
    </div>
  );
};

export default Admin;
